import './css-variables.css'
import 'normalize.css'
import 'packages/semantic-ui-theme/assets/semantic/semantic.min.css'
import '@fortawesome/fontawesome-pro/css/all.min.css'
import './style.css'
import './tailwind-build.css'

import { createGlobalStyle } from 'styled-components'

export const SemanticUICustomGlobalStyle = createGlobalStyle`
  .ui.radio > input:checked + label {
    color: #373f46;
  }
`



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/styles/style.js